import React from 'react';
import strings from '../index';

import Eng from './en.js';
import Esp from './es.js';
import Dan from './da.js';
import Ger from './de.js';
import Fin from './fi.js';
import Swe from './sv.js';
import Fra from './fr.js';
import Hun from './hu.js';

const components = {
  en: Eng,
  es: Esp,
  da: Dan,
  de: Ger,
  fi: Fin,
  sv: Swe,
  fr: Fra,
  hu: Hun
};
const HandlingUserData = (props) => {
  const lang = strings.getLanguage();
  const LangComponent = components[lang];
  return LangComponent
    ? <LangComponent indexPage={props.indexPage} />
    : <Eng indexPage={props.indexPage} />;
};

export default HandlingUserData;
